import { AccessRolesType } from './const'
import { isString, isArray } from 'lodash'

export const windowScrollToTop = (value: number = 0) => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
  window.requestAnimationFrame(() => {
    window.scrollTo({
      top: value,
      behavior: 'smooth'
    })
  })
}

export const copyToClipboardOnAndroid = (textToCopy: string) => {
  let textArea = document.createElement('textarea')
  textArea.value = textToCopy
  textArea.style.position = 'fixed'
  textArea.style.left = '-999999px'
  textArea.style.top = '-999999px'
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  return new Promise((res, rej) => {
    //@ts-ignore
    document.execCommand('copy') ? res() : rej()
    textArea.remove()
  })
}

export const accountHasThisRole = (userRoles: string | string[], accessRoles: AccessRolesType | AccessRolesType[], type: 'all' | 'oneOf') => {
  const userRolesArr = isString(userRoles) ? [userRoles] : userRoles
  const accessRolesArr = isString(accessRoles) ? [accessRoles] : accessRoles

  if (type === 'all') {
    if (isArray(userRolesArr)) {
      return accessRolesArr.every(role => userRolesArr.includes(role))
    }
  }

  if (type === 'oneOf') {
    if (isArray(userRolesArr)) {
      return accessRolesArr.some(role => userRolesArr.includes(role))
    }
  }

  return false
}
